import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72e6448f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=72e6448f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e6448f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72e6448f')) {
      api.createRecord('72e6448f', component.options)
    } else {
      api.reload('72e6448f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72e6448f&scoped=true", function () {
      api.rerender('72e6448f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/journalAccount/capitalFlow/index.vue"
export default component.exports